import { Link } from 'react-router-dom';
import type { TvShow } from '@/mocks/tvShows';

interface TvCardProps {
  show: TvShow;
  size?: 'normal' | 'small';
}

export default function TvCard({ show, size = 'normal' }: TvCardProps) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg ${isSmall ? 'aspect-[3/4]' : 'aspect-[3/4]'} bg-background-200`}>
        <img
          src={show.poster}
          alt={`${show.title} - ${show.englishTitle}`}
          title={`${show.title} ${show.englishTitle} ${show.category}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3 md:p-4">
          <p className="text-xs md:text-sm text-foreground-100 line-clamp-2">
            {show.description}
          </p>
        </div>
        {show.status === '更新中' && (
          <span className="absolute top-2 left-2 bg-primary-500 text-foreground-50 text-[10px] px-2 py-0.5 rounded-md font-medium">
            {show.status}
          </span>
        )}
        {show.rating >= 9.0 && (
          <span className="absolute top-2 right-2 bg-accent-500 text-background-950 text-[10px] px-2 py-0.5 rounded-md font-bold">
            {show.rating}
          </span>
        )}
      </div>
      <div className="mt-2 md:mt-3">
        <h3 className="text-sm md:text-base font-medium text-foreground-100 line-clamp-1 group-hover:text-accent-500 transition-colors">
          {show.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{show.category}</span>
          <span className="text-xs text-foreground-600">|</span>
          <span className="text-xs text-foreground-500">{show.year}</span>
        </div>
        {!isSmall && (
          <p className="text-xs text-foreground-500 mt-1">{show.updateInfo}</p>
        )}
      </div>
    </Link>
  );
}